export const baseModalTitles = {
  baseModalTitleProfileUser: "Perfil de Usuario",
  baseModalTitleMobilePayment: "Depósitos",
  baseModalTitleInviteFriend: "Invitar Amigo",
  baseModalTitleChangePassword: "Cambiar Contraseña",
  baseModalTitleWithdrawal: "Retiro",
  baseModalTitleTransfer: "Transferir Dinero",
  baseModalTitleRegistration: "¡Regístrate y gana!",
  baseModalTitleSupport: "Soporte",
};
